export default {"src":"/_next/static/media/hr.c14d1f0b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};